'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.totals = totals;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function totals() {
    var clazz = function Totals() {
        var defaults = {
            totalPriceWithDiscount: 0,
            totalVatAmount: 0,
            vatList: [],
            totalPriceInclVat: 0,
            totalDiscount: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedTotals) {
            this.totalPriceWithDiscount = updatedTotals.totalPriceWithDiscount;
            this.vatList = updatedTotals.vatList;
            this.totalPriceWithDiscountInclVat = updatedTotals.totalPriceWithDiscountInclVat;
            this.totalDiscount = updatedTotals.totalDiscount;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalVatAmount = resource.totalVatAmount;
        o.vatList = _lodash2.default.map(resource.vatList, function (i) {
            return { pct: i.vatPercentage, amount: i.vatAmount };
        });
        o.totalPriceWithDiscountInclVat = o.totalPriceWithDiscount + o.totalVatAmount;
        o.totalDiscount = resource.totalDiscountAmount;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalVatAmount = resource.totalVatAmount;
        o.vatList = resource.vatList;
        o.totalPriceWithDiscountInclVat = resource.totalPriceWithDiscountInclVat;
        o.totalDiscount = resource.totalDiscount;
        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/totalsModel.js
// module id = 797
// module chunks = 0